import React from "react";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { B2bImageSrc } from "@danishagro/shared/src/helpers/imageSrc.helper";
import { ImageConfig } from "@danishagro/shared/src/content/imageConfigs/imageConfig.enum";
import { useCart } from "@danishagro/shared/src/contexts/cart/cart.context";
import { formatNumber } from "@danishagro/shared/src/helpers/formatNumber.helper";
// import { DA_Checkbox } from "@danishagro/shared/src/components/atoms/Checkbox/Checkbox.component";
import { usePrices } from "@danishagro/shared/src/hooks/usePrices.hook";
import { DA_EmptyStateNoPrice } from "@molecules/EmptyState/NoPrice/NoPrice.component";
import { DA_CartItemMobileProps } from "./CartItemMobile.interface";
import S from "./CartItemMobile.module.scss";

export const DA_CartItemMobile = ({ ...props }: DA_CartItemMobileProps) => {
    const { getDictionaryString } = useTranslations();
    const { currentCulture } = useAppData();
    const { disableCropProtectionDelivery } = useCart();
    const { formatPrice } = usePrices();

    const ImageContent = (
        <img
            src={B2bImageSrc(props.imageUrl, ImageConfig.PdpThumbnail)}
            alt={props.sizedImage.alt}
            width={props.sizedImage.width}
            height={props.sizedImage.height}
            className={S.image}
        />
    );

    return (
        <div className={S.mobilItem}>
            <div className={S.boxImage}>
                {/** Image */}
                <div className={S.imageWrapper}>
                    {props.data.isAdditionalProduct ? (
                        ImageContent
                    ) : (
                        <DA_BasicLink href={props.url} className={S.imageLink}>
                            {ImageContent}
                        </DA_BasicLink>
                    )}
                </div>
            </div>
            <div className={S.boxInfo}>
                {/** Name */}
                <div className={S.numberAndName}>
                    <div className={S.name}>
                        {props.data.isAdditionalProduct ? (
                            props.productName
                        ) : (
                            <DA_BasicLink href={props.url} className={S.nameLink}>
                                {props.productName}
                            </DA_BasicLink>
                        )}
                    </div>
                </div>

                {/** Price */}
                <div className={S.total}>
                    <div className={S.totalAmount}>
                        {`${props.quantity} ${getDictionaryString(props.unit)}`}
                    </div>
                    <div className={S.totalPrice}>
                        {props.linePrice?.totalPrice > 0 ? (
                            formatPrice(props.linePrice?.totalPrice)
                        ) : (
                            <DA_EmptyStateNoPrice small />
                        )}
                    </div>
                </div>

                {props.data.allowCropProtectionDelivery &&
                    !props.hideDeliveryOptions &&
                    disableCropProtectionDelivery && (
                        <span className={S.tag}>
                            {`${getDictionaryString("TotalWieght")}: ${
                                props.data.lineGrossWeight % 1 === 0
                                    ? formatNumber(props.data.lineGrossWeight, currentCulture, {
                                          decimals: 0,
                                      })
                                    : formatNumber(props.data.lineGrossWeight, currentCulture, {
                                          decimals: 2,
                                      })
                            } kg`}
                        </span>
                    )}
            </div>

            <div className={S.boxButton}>
                <button onClick={props.openProductDrawer} disabled={props.dimmed}>
                    <DA_Icon
                        className={S.buttonIcon}
                        useSvgDimensions={true}
                        name={DA_IconNames.ArrowRight}
                    />
                </button>
            </div>
        </div>
    );
};
